<template>
  <div class="fh2 title-section">
    <span v-if="title" class="f-text">
      <div
        class="title-section__bar d-inline-flex fs-2 px-4 py-3 w-100 justify-content-between rounded fw-medium"
      >
        <div v-dompurify-html="title" />
        <div style="min-width: fit-content; place-self: center" class="ms-auto flex-auto my-auto">
          <slot v-if="hasNamedSlot('leftNav')" name="leftNav" />

          <Popper
            v-if="showPreviousStepButton && hasPreviousStepLink"
            :content="$t('messages.back')"
            hover
            arrow
            class="fs-5 align-self-center"
            placement="bottom"
            theme="light"
          >
            <span
              class="fs-3 text-decoration-underline fw-light cursor-pointer d-inline-flex align-items-center"
              @click.prevent="goToPreviousStep()"
            >
              <AppIcon icon="change" />
            </span>
          </Popper>
        </div>
      </div>
    </span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { router } from '@inertiajs/vue3'

export default defineComponent({
  name: 'TitleSection',
  props: {
    title: {
      type: String,
      required: true
    },
    previousStepRoute: {
      type: String,
      default: ''
    },
    showPreviousStepButton: {
      type: Boolean,
      default: true
    }
  },
  setup(__, { slots }) {
    const hasNamedSlot = (name: string): boolean => {
      return !!slots[name]
    }

    return {
      hasNamedSlot
    }
  },
  emits: ['previousStepClick'],
  computed: {
    hasPreviousStepLink(): Boolean {
      return this.previousStepRoute.length > 0
    }
  },
  methods: {
    goToPreviousStep(): void {
      if (this.hasPreviousStepLink) {
        this.$emit('previousStepClick')
        return router.visit(this.previousStepRoute)
      }
    }
  }
})
</script>
